// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3YE0a","content":"styles_content__1Xgli","selectAll":"styles_selectAll__10zbu"};